"use strict";

/**
 * Cette classe permet de simplifier la géolocalisation d'un utilisateur.
 * Elle gère la récupération des coordonnées auprès du navigateur et l'envoi
 * à un service de géolocalisation comme Google ou OpenStreetMap
 */

const PROVIDER_GOOGLE = 1;
const PROVIDER_OPENSTREETMAP = 2;

window.HegydGeolocator = {

    setGoogleMapApiKey: function(apiKey){
        this.googleMapApiKey = apiKey;
    },

    /**
     * Code éxécuté si l'utilisateur refuse la géolocalisation proposée par le navigateur
     */
    geolocationBlocked : function(error, callbackFail){
        switch(error.code){
            case error.TIMEOUT:
                console.log("La requète de géolocalisation a été stoppée car trop longue");
                break;
            case error.POSITION_UNAVAILABLE:
                console.log("Les informations de position sont indisponible");
                break;
            case error.PERMISSION_DENIED:
                console.log("Vous avez refusé d'être géolocalisé");
                break;
            default:
                console.log("Une erreur de géolocalisation est survenue");
        }

        if ( callbackFail !== undefined ){
            callbackFail(error);
        } else {
            console.log('Pas de callbackFail défini');
        }

    },


    /**
     * WIP - A finaliser en utilisant l'API PLACE et pas l'URL comme entamé
     * @param position
     * @param callbackSuccess
     */
    geolocateWithGoogleMap: function(position, callbackSuccess){

        let coordinates = position.coords;
        let stringCoordinates = coordinates.latitude+","+coordinates.longitude;

        let googleMapApiUrl = "//maps.google.com/maps/api/geocode/json?";

        if( this.googleMapApiKey !== undefined ){
            googleMapApiUrl+= "key="+this.googleMapApiKey+"&";
        } else {
            console.error("Google Map API Key missing");
        }

        // Problème CORS : Il faut utiliser l'API Places lorsqu'on est en javascript
        // https://stackoverflow.com/questions/42180788/how-to-use-cors-to-implement-javascript-google-places-api-request
        $.ajax({
            url: googleMapApiUrl,
            type: 'get',
            dataType: 'jsonp',
            data: {
                sensor: false,
                address: stringCoordinates
            },
        }).done(function (response) {
            if ( callbackSuccess !== undefined ){
                callbackSuccess(response);
            } else {
                console.log('Pas de callbackSuccess défini');
            }
        }).fail(function (error) {
            console.log(error);
        });

    },

    geolocateWithOpenStreetMap: function(position, callbackSuccess){

        let coordinates = position.coords;
        let stringCoordinates = coordinates.latitude+","+coordinates.longitude;

        $.ajax({
            url: "//nominatim.openstreetmap.org/search",
            type: 'get',
            data: {
                q: stringCoordinates,
                format: "json",
                addressdetails: 1,
                limit: 1
            }
        }).done(function (response) {
            if ( callbackSuccess !== undefined ){
                callbackSuccess(response);
            } else {
                console.log('Pas de callbackSuccess défini');
            }
        }).fail(function (error) {
            console.log(error);
        });

    },


    /****** Méthodes pour récupérer des infos spécifiques avec callbacks ******/

    /**
     * Géolocalisation avec l'API Google
     * @requires Service payant requiert une clef d'API avec une
     */
    geolocateUserWithGoogle: function (callbackSuccess, callbackFail) {

        var geolocationAuthorized = function(position) {
            HegydGeolocator.geolocateWithGoogleMap(position, callbackSuccess);
        };

        var geolocationBlocked = function(error) {
            HegydGeolocator.geolocationBlocked(error, callbackFail);
        };

        // La ligne ci-dessous cherche la position de l'utilisateur et déclenchera la demande d'accord
        navigator.geolocation.getCurrentPosition(
            geolocationAuthorized,
            geolocationBlocked
        );

    },

    // Géolocalisation avec OpenStreetmap
    geolocateUserWithOsm : function (callbackSuccess, callbackFail) {

        var geolocationAuthorized = function(position) {
            HegydGeolocator.geolocateWithOpenStreetMap(position, callbackSuccess);
        };

        var geolocationBlocked = function(error) {
            HegydGeolocator.geolocationBlocked(error, callbackFail);
        };

        // La ligne ci-dessous cherche la position de l'utilisateur et déclenchera la demande d'accord
        navigator.geolocation.getCurrentPosition(
            geolocationAuthorized,
            geolocationBlocked
        );

    },

    // Géolocalisation
    geolocateUser : function (provider, callbackSuccess, callbackFail) {

        switch(provider){
            case PROVIDER_GOOGLE:
                this.geolocateUserWithGoogle(callbackSuccess, callbackFail);
                break;
            case PROVIDER_OPENSTREETMAP:
                this.geolocateUserWithOsm(callbackSuccess, callbackFail);
                break;
            default:
                console.log("Pas de correspondance avec un provider connu");
        }

    },

    /**
     * Géolocalisation de l'utilisateur et remplissage du champ identifié avec la ville trouvée
     * @param provider
     * @param targetFieldSelector
     */
    geolocateUserCityToField : function (provider, targetFieldSelector, callbackSuccess, callbackFail) {

        /**
         * Au chargement de la page en tente de renseigner automatiquement la ville
         * où le visiteur a été géolocalisé
         */
        HegydGeolocator.geolocateUser(
            PROVIDER_OPENSTREETMAP,
            // Callback en cas succès
            function(response){
                // Si la réponse n'est pas vide et qu'il y a une ville, on l'inject
                // dans le champ de recherche
                if (
                    response[0] !== undefined &&
                    response[0]["address"] !== undefined
                ){
                    var city = '';
                    if ( response[0]["address"]["city"] !== undefined ){
                        city = response[0]["address"]["city"];
                        console.info('Use city : '+city);
                    } else if ( response[0]["address"]["town"] !== undefined ) {
                        city = response[0]["address"]["town"];
                        console.info('Use town : '+city);
                    } else if ( response[0]["address"]["village"] !== undefined ) {
                        city = response[0]["address"]["village"];
                        console.info('Use village : '+city);
                    } else {
                        city = response[0]["address"]["county"];
                        console.info('Use county : '+city);
                    }

                    var $field = $(targetFieldSelector);
                    if ( $field !== undefined && $field.length > 0 ){
                        $field.val(city);
                    }
                }
                callbackSuccess(response);
                // $( ".jsSearchShopsButton" ).siblings('.jsSearchButton').trigger('click');

            },
            // Callcback en cas de probleme
            callbackFail
        );

    },

    /**
     * Géolocalisation de l'utilisateur et remplissage du champ identifié avec le ville trouvée
     * @WIP A finaliser en utilisant l'API Place au lieu de l'API JSON comme pour OpenStreetMap
     * @param provider
     * @param targetFieldSelector
     */
    geolocateUserCityToFieldWithGoogle : function (provider, targetFieldSelector, callbackSuccess, callbackFail) {

        /**
         * Au chargement de la page en tente de renseigner automatiquement la ville
         * où le visiteur a été géolocalisé
         */
        HegydGeolocator.geolocateUser(
            PROVIDER_GOOGLE,
            // Callback en cas succès
            function(response){
                // Si la réponse n'est pas vide et qu'il y a une ville, on l'inject
                // dans le champ de recherche
                if (
                    response[0] !== undefined &&
                    response[0]["address"] !== undefined
                ){
                    var city = '';
                    if ( response[0]["address"]["city"] !== undefined ){
                        city = response[0]["address"]["city"];
                        console.info("Use city : "+city);
                    } else if ( response[0]["address"]["village"] !== undefined ) {
                        city = response[0]["address"]["village"];
                        console.info("Use village : "+city);
                    } else {
                        city = response[0]["address"]["county"];
                        console.info("Use county : "+city);
                    }

                    var $field = $(targetFieldSelector);
                    if ( $field !== undefined && $field.length > 0 ){
                        $field.val(city);
                    }
                }
                callbackSuccess(response);
                // $( ".jsSearchShopsButton" ).siblings('.jsSearchButton').trigger('click');

            },
            // Callcback en cas de probleme
            callbackFail
        );

    },


};